<template>
    <div
        :class="[
            'rounded-[12.8px] border border-gray-200 bg-white px-[21px] py-[42px] transition-all duration-200 h-auto flex flex-col items-center justify-center text-center mb-40',
            props.disableTopMargin ? '' : 'mt-[42px]',
        ]"
    >
        <div class="w-[500px] mx-auto">
            <img
                v-if="imgSrc"
                :src="imgSrc"
                :alt="imgAlt"
                :class="[
                    'block mx-auto mb-12',
                    `w-[${props.customWidth}px]`,
                    `h-[${props.customHeight}px]`,
                ]"
            />

            <div class="mb-12">
                <h2
                    class="font-inter font-semibold text-[21px] leading-[1.42] tracking-[0] text-center"
                >
                    {{ title }}
                </h2>

                <!--                <p-->
                <!--                    v-if="bodyText || emphasisText"-->
                <!--                    class="mx-auto mt-2 max-w-[520px] px-4 text-center leading-[1.6]"-->
                <!--                >-->
                <!--                    {{ bodyText }}-->
                <!--                    <template v-if="bodyText && emphasisText">,&nbsp; </template-->
                <!--                    ><span-->
                <!--                    v-if="emphasisText"-->
                <!--                    class="text-gray-700 font-semibold"-->
                <!--                >{{ emphasisText }}</span-->
                <!--                ><template v-if="showDot">.</template>-->
                <!--                </p>-->

                <div
                    class="mx-auto mt-2 max-w-[520px] px-4 text-center leading-[1.6]"
                >
                    <slot name="body">
                        <p v-if="bodyText || emphasisText">
                            {{ bodyText
                            }}<template v-if="bodyText && emphasisText"
                                >,&nbsp;</template
                            >
                            <span
                                v-if="emphasisText"
                                class="text-gray-700 font-semibold"
                                >{{ emphasisText }}</span
                            >
                            <template v-if="showDot">.</template>
                        </p>
                    </slot>
                </div>
            </div>

            <div v-if="buttonLabel && buttonHref">
                <component
                    :is="linkComponent"
                    class="cursor-pointer"
                    :href="buttonHref"
                >
                    <AtomicButton :color="buttonColor" :size="buttonSize">
                        {{ buttonLabel }}
                    </AtomicButton>
                </component>
            </div>

            <!-- optional slot for custom actions -->
            <slot v-else name="actions" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ButtonColor = "yellow" | "blue" | "gray" | string;
type ButtonSize = "sm" | "md" | "lg" | string;

const props = withDefaults(
    defineProps<{
        imgSrc?: string;
        imgAlt?: string;

        title: string;

        bodyText?: string;
        emphasisText?: string;
        showDot?: boolean;

        buttonLabel?: string;
        buttonHref?: string;

        buttonColor?: ButtonColor;
        buttonSize?: ButtonSize;

        useInertiaLink?: boolean;

        disableTopMargin?: boolean;

        customWidth: number;
        customHeight: number;
    }>(),
    {
        imgAlt: "",
        showDot: true,
        buttonColor: "yellow",
        buttonSize: "lg",
        useInertiaLink: true,

        disableTopMargin: true,

        customWidth: 375,
        customHeight: 259,
    },
);

const linkComponent = computed(() =>
    props.useInertiaLink ? "inertia-link" : "a",
);
</script>
